import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AudioCaptureService } from 'src/app/moov-common/services/audio-capture/audio-capture.service';

@Component({
  selector: 'app-audio-capture',
  templateUrl: './audio-capture.component.html',
  styleUrls: ['./audio-capture.component.scss']
})
export class AudioCaptureComponent extends BaseComponent implements OnInit, OnChanges{
  @Input() captureEnabled = false;
  @Output() recordingCompleted = new EventEmitter<Blob>();
  @Output() recordingStarted = new EventEmitter<void>();

  

  private recordingCompletedSub: Subscription | null = null;
  private recordingStartedSub: Subscription | null = null;
  
  isRecording = false;

  constructor(private audioCaptureService: AudioCaptureService) {
    super();
  }

  async ngOnInit() {
    if (this.captureEnabled){
      await this.initCaptureService();
    }
  }

  async initCaptureService(){
    console.log('initCaptureService');
    await this.audioCaptureService.init();
    // Subscribe to the service's recording completed events
    this.recordingCompletedSub = this.audioCaptureService.recordingCompleted$.subscribe(blob => {
      this.isRecording = false;
      // Emit the blob to the parent component
      this.recordingCompleted.emit(blob);
    });

    // for auto start recording on voice detection
    this.recordingStartedSub = this.audioCaptureService.recordingStarted$.subscribe(() => {
      this.isRecording = true;
      this.recordingStarted.emit();
    });    
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.ifChanged(changes.captureEnabled,() => {
      if (!this.captureEnabled){
        this.stopCapturing();
      }
      else{
        this.initCaptureService();
      }
    });
  }
  
  start() {
    this.isRecording = true;
    this.audioCaptureService.startRecording();
    this.recordingStarted.emit();
  }

  stop() {
    this.isRecording = false;
    this.audioCaptureService.endRecording().then((blob) => {
      this.recordingCompleted.emit(blob);
    });
  }

  stopCapturing(){
    console.log('stopCapturing');
    this.audioCaptureService.stopCapturing();

    if (this.recordingCompletedSub){
      this.recordingCompletedSub.unsubscribe();
      this.recordingCompletedSub = null;
    }

    if (this.recordingStartedSub){
      this.recordingStartedSub.unsubscribe();
      this.recordingStartedSub = null;
    }
  }

  ngOnDestroy(): void {
    this.stopCapturing();
  }
}